import { ElementUtils } from "../utils/element";
import { InlineType } from "../types";
function isLinkElement(node) {
  return ElementUtils.isInline(node) && node.type === InlineType.Link;
}
function isLinkEntry(inline) {
  return ElementUtils.isInline(inline[0]) && inline[0].type === InlineType.Link;
}
export {
  isLinkElement,
  isLinkEntry
};
//# sourceMappingURL=types.js.map